import { render, staticRenderFns } from "./ParlayPreviewModal2.vue?vue&type=template&id=39ce2f7a&scoped=true&"
import script from "./ParlayPreviewModal2.vue?vue&type=script&lang=js&"
export * from "./ParlayPreviewModal2.vue?vue&type=script&lang=js&"
import style0 from "./ParlayPreviewModal2.vue?vue&type=style&index=0&id=39ce2f7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ce2f7a",
  null
  
)

export default component.exports